// @ts-nocheck
import React from 'react';

const CarrierDeleteAlert = React.lazy(
  () => import('@/containers/Alerts/Carriers/CarrierDeleteAlert'),
);

export default [{ name: 'carrier-delete', component: CarrierDeleteAlert }];